<template>
    <v-btn 
        v-show="isVisible" 
        @click="scrollToTop" 
        bottom 
        right 
        fixed
        fab
        :class="{ 'scroll-top-button': true, 'scroll-top-button-playerOn': currentPodcast }"
    >
        <v-icon>
            mdi-chevron-up
        </v-icon>
    </v-btn>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            isVisible: false
        }
    },
    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
        toggleVisibility() {
            this.isVisible = window.scrollY > 1000;
        },
    },
    computed: {
        ...mapGetters('rss', ['currentPodcast'])
    },
    mounted() {
        window.addEventListener('scroll', this.toggleVisibility)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.toggleVisibility)
    },
}
</script>
<style lang="scss">
.scroll-top-button {
    &-playerOn {
        transform: translateY(-100px);

        @media (max-width: 710px) {
            transform: translateY(-150px);
        }

        @media (max-width: 530px) {
            transform: translateY(-200px);
        }
    }
}
</style>